import 'moment/locale/ru';

import moment from 'moment-timezone';

export const formatDateTime = (date: Date, format: string) => {
  return moment(date).locale('ru').format(format);
};
